"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var Constants_1 = require("./Constants");
;
var OAuthTokenService = (function () {
    function OAuthTokenService(context, endpointConfig) {
        this.context = context;
        this.endpointConfig = endpointConfig;
    }
    OAuthTokenService.prototype.getAccessToken = function () {
        var localStorage = this.context.localStorage;
        return localStorage.getItem(Constants_1.default.TokenKeys.ACCESS_TOKEN);
    };
    OAuthTokenService.prototype.getAccessRefreshToken = function () {
        var localStorage = this.context.localStorage;
        return localStorage.getItem(Constants_1.default.TokenKeys.REFRESH_TOKEN);
    };
    OAuthTokenService.prototype.refreshAccessToken = function () {
        var localStorage = this.context.localStorage;
        var metricService = this.context.metricService;
        var token = this.getAccessRefreshToken();
        if (!token) {
            var error = {
                config: null,
                request: null,
                response: {
                    status: Constants_1.default.HttpStatuses.CANCELLED,
                    statusText: "Cancelled",
                    data: null,
                    config: null,
                    request: null
                }
            };
            return Promise.reject(error);
        }
        metricService.newCounterMetric('TokenRefresh');
        if (this.didAccessTokenExpireEarly()) {
            metricService.newCounterMetric('UntimelyTokenRefresh');
        }
        return axios_1.default.post(this.endpointConfig.getGorillaBoyEndpoint() + '/gb/api/v1/token/refresh', {
            RefreshToken: token
        })
            .then(function (response) {
            var res = response.data;
            localStorage.setItem(Constants_1.default.TokenKeys.ACCESS_TOKEN, res.AccessToken);
            localStorage.setItem(Constants_1.default.TokenKeys.ACCESS_TOKEN_EXPIRATION, res.ExpirationDateTime);
            if (res.RefreshToken) {
                localStorage.setItem(Constants_1.default.TokenKeys.REFRESH_TOKEN, res.RefreshToken);
            }
        });
    };
    OAuthTokenService.prototype.didAccessTokenExpireEarly = function () {
        var localStorage = this.context.localStorage;
        var expireTimeStr = localStorage.getItem(Constants_1.default.TokenKeys.ACCESS_TOKEN_EXPIRATION), expireTimeVal, currentTimeVal;
        if (expireTimeStr) {
            expireTimeVal = (new Date(expireTimeStr)).valueOf();
            currentTimeVal = (new Date()).valueOf();
            return expireTimeVal > currentTimeVal;
        }
        return false;
    };
    return OAuthTokenService;
}());
exports.default = OAuthTokenService;
